import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@ipc/ipc-components';

import { PanelContent } from '../../../styles';
import { FormLabel, DayPickerInput, Checkbox } from '../../../elements';

const ValidityPeriodComponent = ({
  values, validations, dateChangeHandler, checkboxChangeHandler,
}) => (
  <Panel title="Validity Period" expanded>
    <PanelContent>
      <div className="FormRow">
        <div className="FormRowInline">
          <FormLabel title="Start date of run of pre-settlement report" required forDayPicker hasError={!validations.startDate}>
            <DayPickerInput name="startDate" value={values.startDate} onChange={dateChangeHandler('startDate')} />
          </FormLabel>
        </div>

        <div className="FormRowInline">
          <FormLabel title="Stop date of run of pre-settlement report" required forDayPicker hasError={!validations.stopDate}>
            <DayPickerInput name="stopDate" value={values.stopDate} onChange={dateChangeHandler('stopDate')} />
          </FormLabel>
        </div>

        <div className="ShortFormRowInline">
          <u><i>Note: Not pre-settlement reporting period</i></u>
        </div>
      </div>

      <div className="FormRow">
        <Checkbox name="exPeriod" checked={!!values.exPeriod} onChange={checkboxChangeHandler} label="Exception Period" />
      </div>

      {values.exPeriod && (
        <div className="FormRow">
          <div className="FormRowInline">
            <FormLabel title="Start Date" required forDayPicker hasError={!validations.exStartDate}>
              <DayPickerInput name="exStartDate" value={values.exStartDate} onChange={dateChangeHandler('exStartDate')} />
            </FormLabel>
          </div>

          <div className="FormRowInline">
            <FormLabel title="End Date" required forDayPicker hasError={!validations.exStopDate}>
              <DayPickerInput name="exStopDate" value={values.exStopDate} onChange={dateChangeHandler('exStopDate')} />
            </FormLabel>
          </div>
        </div>
      )}
    </PanelContent>
  </Panel>
);

ValidityPeriodComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  dateChangeHandler: PropTypes.func,
  checkboxChangeHandler: PropTypes.func,
};

export default ValidityPeriodComponent;
